import React from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowSmRightIcon } from '@heroicons/react/outline';

import { usePrice } from 'contexts';
import { Currency } from 'utils/types';
import { formatCount } from 'utils/number';
import { ActionToButton } from 'components/Button';

const PolywaveBanner = () => {
  const { t } = useTranslation();
  const { maticTokenPrices } = usePrice();
  const waveUsd = maticTokenPrices[Currency.WAVE]?.[Currency.USD];
  return (
    <div className="space-y-2">
      <a
        href="https://polywave.finance/pools"
        className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0 rounded-xl px-4 md:px-6 py-6 md:py-8 bg-polywave-primary uppercase text-white text-center"
        style={{ backgroundImage: 'url(/img/polywave/banner_bg.png)' }}
      >
        <span className="block rounded-full space-x-2 pr-4 bg-polywave-dark border border-polywave-light text-lg">
          <img src="/img/tokens/wave.png" className="w-10 h-10 inline" alt="WAVE" />
          <span className="align-middle">${waveUsd ? formatCount(waveUsd, 4) : '-'}</span>
        </span>
        <span className="block text-28 tracking-widest">{t('polywave_banner.body')}</span>
        <span className="block rounded-full py-1 pl-5 md:pl-5 pr-3 md:pr-4 bg-polywave-light text-xs text-polywave-dark">
          <span className="align-middle">{t('polywave_banner.action_banner')}</span>&nbsp;&nbsp;
          <ArrowSmRightIcon className="inline w-5 h-5 -mt-0.5" />
        </span>
      </a>
      <div className="flex flex-col md:flex-row items-center justify-center md:space-x-4 space-y-2 md:space-y-0">
        <ActionToButton
          actionTo="https://docs.surf.finance/core-dapps/polywave"
          actionTitle={t('polywave_banner.action_info')}
          isThemed={false}
        />
        <ActionToButton
          actionTo="https://www.dextools.io/app/quickswap/pair-explorer/0x1a3b6d6be3570dabe0e03a15a6f43e712520fd0d "
          actionTitle={t('polywave_banner.action_chart')}
          isThemed={false}
        />
        <ActionToButton
          actionTo="https://quickswap.exchange/#/swap?outputCurrency=0x4DE7FEA447b837d7E77848a4B6C0662a64A84E14"
          actionTitle={t('polywave_banner.action_trade')}
          isThemed={false}
        />
      </div>
    </div>
  );
};

export default PolywaveBanner;
